module.exports = __webpack_public_path__ + "img/progress_072.5b98b599.png";